<template>
  <div id="main-wrapper">
    <Sidebar />
    <div id="content-wrapper">
      <Topbar />
      <div class="container-fluid">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "@/components/sidebar/Sidebar";
import Topbar from "@/components/topbar/Topbar";

export default {
  components: {
    Sidebar,
    Topbar,
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Karla:wght@400;500;600;700&display=swap");
@import "src/assets/scss/variables";

#main-wrapper {
  font-family: "Karla", sans-serif;
}

#content-wrapper {
  width: calc(100% - #{$sidebar-width});
  margin-left: $sidebar-width;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/AppLayout.vue